/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Compare_Row_License_CcInputs */

const en_cad_compare_row_license_cc = /** @type {(inputs: Cad_Compare_Row_License_CcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open source (MIT OR Apache-2.0)`)
};

/**
* | output |
* | --- |
* | "Open source (MIT OR Apache-2.0)" |
*
* @param {Cad_Compare_Row_License_CcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_compare_row_license_cc = /** @type {((inputs?: Cad_Compare_Row_License_CcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Compare_Row_License_CcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_compare_row_license_cc(inputs)
});
export { cad_compare_row_license_cc as "cad.compare.row_license_cc" }